import React from 'react';
import { EanAvailabilityMap } from '../../../ws/result/WsStockInfo';
import { Store } from '../../../store';
import { __ } from 'first-intl';
import { Messages } from '../../../messages';

type ArticleStockCountStoreProps = { eanAvailabilityMap: EanAvailabilityMap | null };
type ArticleStockCountOwnProps = { ean?: string };
export type ArticleStockCountProps = ArticleStockCountStoreProps & ArticleStockCountOwnProps;

export const UnwiredArticleStockCount: React.FC<ArticleStockCountProps> = ({ eanAvailabilityMap, ean }) => {
    const stockCount = eanAvailabilityMap && ean ? eanAvailabilityMap[ean] : undefined;
    return (
        <>
            {__(
                stockCount !== undefined
                    ? Messages.dynamic.STOCK_COUNT(stockCount)
                    : // TODO(VL): Display a spinner as long as the request is still pending
                      { id: 'article.box.stockInfo.unknown' }
            )}
        </>
    );
};

export const ArticleStockCount = Store.wire<ArticleStockCountStoreProps, ArticleStockCountOwnProps>(
    UnwiredArticleStockCount,
    ({ eanAvailabilityMap }) => ({ eanAvailabilityMap })
);
